import React from 'react';
import NextLink from 'next/link';
import { Routes } from 'utils/routes';
import getConfig from 'next/config';

const Footer = (props) => {
    const { publicRuntimeConfig } = getConfig();
    return (
        <footer { ...props }>
            <section>
                <ul>
                    <li>
                        <div></div>
                        <p>
                            Symbion
                            <br />
                            Fruebjergvej 3
                            <br />
                            2100 København Ø
                            <br />
                            CVR 39063158
                            <br />
                            <a href="tel:+4593838372">Telefon: 93 83 83 72</a>
                            <br />
                            <a href="mailto:kontakt@penly.dk">Email: kontakt@penly.dk</a>
                        </p>
                        <div>
                            <a href="https://www.facebook.com/penlydk/" target="_new" className="facebook"></a>
                            <a href="https://www.linkedin.com/company/penlydk/" target="_new" className="linkedin"></a>
                        </div>
                    </li>
                    <li>
                        <h5>Værktøjer</h5>
                        <ul>
                            <li>
                                <NextLink href={ Routes.PensionCheck.LandingPage }>Penly PensionsTjek</NextLink>
                            </li>

                            { !publicRuntimeConfig.mortgageCheckDeactivated && (
                                <li>
                                    <NextLink href={ Routes.MortgageCheck.LandingPage }>Penly RealkreditTjek</NextLink>
                                </li>
                            ) }
                            <li>
                                <NextLink href={ Routes.InvestCheck.LandingPage }>Penly InvestTjek</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.PenlyPlay.LandingPage }>Penly Play</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.PensionCheck.KlatPensionLandingPage }>Klatpension</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.Dictionary.LandingPage }>Ordbog</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.Services }>Digitale værktøjer</NextLink>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h5>Information</h5>
                        <ul>
                            <li>
                                <NextLink href={ Routes.FAQ }>FAQ</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.AboutPenly }>Om Os</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.AboutAdvice }>Om rådgivningen</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.Contact }>Kontakt</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.ForPartners }>For partnere</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.ForCompanies }>For virksomheder</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.PenlyPanel.Signup }>Penly Panelet</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.Knowledge.LandingPage }>Events og webinarer</NextLink>
                            </li>
                            <li>
                                <a href='https://app.heyloyalty.com/subscribe/24007/7082' target="_new">Nyhedsbrev</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h5>Sikkerhed og Data</h5>
                        <ul>
                            <li>
                                <NextLink href={ Routes.PrivacyPolicy }>Privatlivspolitik</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.Terms }>Betingelser</NextLink>
                            </li>
                            <li>
                                <NextLink href={ Routes.Cookies }>Cookies</NextLink>
                            </li>
                        </ul>
                    </li>
                </ul>
            </section>
        </footer>
    );
};

export default Footer;
